<p-panel [style]="{ 'margin-top': '1em' }" styleClass="panel-shadow">
  <p-header>
    <div class="panel-header">Vehicle Cleanliness</div>
  </p-header>

  <div
    *ngIf="awaitingAllocation; else showDetails"
    class="py-3 text-center"
    style="font-weight: 500; color: #999"
  >
    Awaiting Allocation
  </div>

  <ng-template #showDetails>
    <div class="pb-1">
      <div>
        <div class="style2023" style="margin-top: 0.5em">
          <div class="input-group">
            <div class="input-group-prepend white-space-nowrap">Pick-up</div>
            <div class="input-group-item">
              {{
                getVehicleCleanliness(
                  vehicleCleanlinessTask?.vehicleCleanlinessDetail?.pickupCleanliness
                )
              }}
            </div>
          </div>
          <div class="mt-2 pl-1" style="word-break: break-word; width: 100%">
            <span class="text-gray-600">Comment: </span
            ><span>{{
              vehicleCleanlinessTask?.vehicleCleanlinessDetail?.pickupCleanlinessComment
            }}</span>
          </div>
        </div>

        <div class="horizontal-divider"></div>

        <div class="style2023" style="margin-top: 0.5em">
          <div class="input-group">
            <div class="input-group-prepend white-space-nowrap">Drop-off</div>
            <div class="input-group-item">
              {{
                getVehicleCleanliness(
                  vehicleCleanlinessTask?.vehicleCleanlinessDetail?.dropoffCleanliness
                )
              }}
            </div>
          </div>
          <div class="mt-2 pl-1" style="word-break: break-word; width: 100%">
            <span class="text-gray-600">Comment: </span
            ><span>{{
              vehicleCleanlinessTask?.vehicleCleanlinessDetail?.dropoffCleanlinessComment
            }}</span>
          </div>
        </div>

        <div class="horizontal-divider"></div>

        <div class="text-right" *ngIf="organisationTypeId == 1">
          <button
            pButton
            label="Change"
            (click)="showEditCleanlinessDialog()"
            class="ui-button-secondary"
          ></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-panel>

<p-dialog
  header="Change Vehicle Cleanliness"
  [(visible)]="editCleanlinessDialogVisible"
  [modal]="true"
  [style]="{ width: '500px' }"
  (onShow)="onDialogShow()"
>
  <form [formGroup]="vehicleCleanlinessForm" class="style2023">
    <div class="ui-g" style="position: relative">
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Pick-up Cleanliness</label>
        </div>
        <div class="ui-grid-col-8">
          <div
            class="input-group-item"
            *ngIf="organisationTypeId == OrganisationTypeEnum.Engineius"
          >
            <p-dropdown
              [options]="vehicleCleanlinessSelectItems"
              [style]="{ width: '100%', 'min-width': '0px' }"
              formControlName="pickupCleanliness"
            ></p-dropdown>
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Comment</label>
        </div>
        <div class="ui-grid-col-8">
          <textarea
            pInputTextarea
            formControlName="pickupCleanlinessComment"
            [rows]="2"
            [maxlength]="50"
            style="width: 100%"
          ></textarea>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Drop-off Cleanliness</label>
        </div>
        <div class="ui-grid-col-8">
          <div
            class="input-group-item"
            *ngIf="organisationTypeId == OrganisationTypeEnum.Engineius"
          >
            <p-dropdown
              [options]="vehicleCleanlinessSelectItems"
              [style]="{ width: '100%', 'min-width': '0px' }"
              formControlName="dropoffCleanliness"
            ></p-dropdown>
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Comment</label>
        </div>
        <div class="ui-grid-col-8">
          <textarea
            pInputTextarea
            formControlName="dropoffCleanlinessComment"
            [rows]="2"
            [maxlength]="50"
            style="width: 100%"
          ></textarea>
        </div>
      </div>
    </div>
    <p-footer>
      <div class="text-right">
        <button
          type="button"
          (click)="editCleanlinessDialogVisible = false"
          pButton
          label="Cancel"
          class="ui-button ui-button-tertiary"
        ></button>
        <button
          type="button"
          pButton
          label="Save"
          class="ui-button ui-buttion-primary"
          (click)="saveVehicleCleanliness()"
        ></button>
      </div>
    </p-footer>
  </form>
</p-dialog>
